

import {
    getReviewList,
    createReview,
} from "../apis/api_review.js";

import { listMode } from '../utils/table';

const state = {
    filters: { mode: listMode.list, userId: 0},
    filtersPage: { mode: listMode.page, userId: 0},
    items: [],
    item: {},
    totalCount: 0,

    itemWrite: {
        id:'',
        userId:'',
        dtype:'',
        bookingId:'',
        brandName:'',
        dealerName:'',
        shopName:'',
        scName:'',
        modelName:'',
        trimName:'',
        title:'',
        score:'',
        rating:'',
        detailScore:'',
        content:'',
        answer:'',
        type:'',
    },

    reviewList: {
        sc: {
            score: '',
            rating: '',
            detailScore: '',
            content:'', 
            dtype:'',
        },
        shop: {
            score: '',
            rating: '',
            detailScore: '',
            content:'',  
            dtype:'',
        },
        trim: {
            score: '',
            rating: '',
            detailScore: '',
            content:'',  
            dtype:'',
        },
    },
};

const getters = {
};

const mutations = {
    SET_REVIEW_LIST(state, data) {
        state.items = data.content;
        state.totalCount = data.totalElements;
    },
    
    SET_REVIEW_LIST_PAGE(state, data) {
        data.content.forEach( (item) => {
            state.items.push(item);
        })
        if(state.totalCount != data.totalElements)
            state.totalCount = data.totalElements;
    },

    CLEAR_REVIEW(state) {
        state.item = {};
    },

    SET_REVIEW_WRITE(state, review) {
        state.itemWrite = review;
    },

    CLEAR_REVIEW_LIST(state) {
        state.items = [];
        state.totalCount = 0;
    }
};

const actions = {

    async GET_REVIEW_LIST({ state, commit }, params = {}) {
        let filters = { ...state.filters,...params };
        
        try {
            const response = await getReviewList(filters);
            commit('SET_REVIEW_LIST', response.data.data)
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },

    async GET_REVIEW_LIST_PAGE({ state, commit }, params = {}) {
        let filters = { ...state.filtersPage,...params };
        
        try {
            const response = await getReviewList(filters);
            commit('SET_REVIEW_LIST_PAGE', response.data.data)
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },

    async CREATE_REVIEW(context, review) {
        try {
            const response = await createReview(review);
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },
};

export default {mutations, state, actions, getters};